module.exports = __webpack_public_path__ + "static/media/Event-09.0956fb1c.svg";